<template>
  <div class="income-comparison">
    <svg v-if="chart" class="income-chart" viewBox="0 0 280 200" role="img" :aria-label="'本月缴费 ' + chart.bars[0].text + ' 元，消课收入 ' + chart.bars[1].text + ' 元'">
      <g v-for="(tick, index) in chart.ticks" :key="'tick-' + index">
        <line x1="42" x2="268" :y1="tick.y" :y2="tick.y" stroke="#e9edf2" stroke-dasharray="3 4" />
        <text x="35" :y="tick.y + 3" text-anchor="end" class="tick">{{ tick.text }}</text>
      </g>
      <line x1="42" x2="268" :y1="chart.baseline" :y2="chart.baseline" stroke="#dce2e9" />
      <g v-for="(bar, index) in chart.bars" :key="index">
        <rect :x="bar.x" :y="bar.y" width="46" :height="bar.height" rx="4" :fill="index === 0 ? '#d75e60' : '#8aa5bd'"><title>{{ labels[index] }}：{{ bar.text }} 元</title></rect>
        <text :x="bar.x + 23" :y="bar.labelY" text-anchor="middle" class="amount">{{ bar.text }}</text>
        <text :x="bar.x + 23" y="188" text-anchor="middle" class="caption">{{ labels[index] }}</text>
      </g>
    </svg>
    <div v-else class="income-unavailable">暂无可展示的图表数据</div>
    <div class="income-caption"><span>单位：元</span><span>当前校区 · 本月累计</span></div>
  </div>
</template>

<script>
import { incomeChart } from '../pages/home/config/incomeChart'
export default {
  name: 'HomeIncomeComparison',
  props: { recharge: { default: null }, revenue: { default: null } },
  data: () => ({ labels: ['本月缴费', '消课收入'] }),
  computed: { chart() { return incomeChart(this.recharge, this.revenue) } }
}
</script>

<style scoped>
.income-chart{display:block;width:100%;height:auto;max-height:260px;overflow:visible}
.tick{fill:#8994a3;font-size:9px}.amount{fill:#596a7e;font:11px Arial,sans-serif}.caption{fill:#748092;font-size:11px}
.income-caption{display:flex;justify-content:space-between;gap:12px;font-size:11px;color:#8b95a3;margin:6px 0 0}
.income-unavailable{min-height:210px;display:flex;align-items:center;justify-content:center;color:#8994a3;font-size:13px}
</style>
